/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Citrus } from "./modelCitrus";

class ControllerCitrus extends ControllerModel {
    constructor() {
        super("ControllerCitrus");

        this.setNewNode = (callback) => {
            let citrus = new Citrus();
            citrus.decorate(callback);

            this.addNode(citrus);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let citrus = new Citrus();
            citrus.copyFrom(node);
            citrus.decorate(callback);
            this.addNode(citrus)
        }

        this.getProperties = async (node) => {
            let n = new Citrus();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Citrus();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerCitrus };